import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import Select from "react-select";
import moment from "moment";
import { academylist, notilist } from "../../../services/admin";

// Read-only circular report. Filter by academy (super-admin); the matching
// circulars are shown in an ag-grid table and can be exported to CSV. Circulars
// share the notification data source (notilist) used by the Circular List screen.
const CircularReport = () => {
  const isSuperAdmin = localStorage.getItem("Role") === "1";

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [rowData, setRowData] = useState([]);

  const columnDefs = [
    { headerName: "Title", field: "title", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Date", field: "date", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Time", field: "time", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Message", field: "message", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Sent To", field: "sent_role", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
    { headerName: "Academy", field: "academy_name", sortable: true, resizable: true, filter: true, floatingFilter: true, cellStyle: { textAlign: "left" } },
  ];

  useEffect(() => {
    academylist().then((res) => {
      if (res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((item) => ({
          value: item.id,
          label: item.name + " - " + item.code,
        }));
        setACList(arr);

        // Default to the academy chosen at login (matches other report screens).
        let defaultAca = "";
        if (localStorage.getItem("AAcademy") != null) {
          defaultAca =
            arr.find((a) => a.value == localStorage.getItem("AAcademy")) || "";
          if (defaultAca) setAcaID(defaultAca);
        }
        loadCirculars(defaultAca);
      } else {
        loadCirculars("");
      }
    });
  }, []);

  function loadCirculars(academy) {
    setRowData([]);
    const temp = new FormData();
    if (isSuperAdmin && academy && academy.value) {
      temp.append("academy_id", academy.value);
    }

    notilist(temp).then((res) => {
      if (res && res.status === true) {
        const data = ((res.data && res.data.details) || []).map((item) => ({
          ...item,
          date: item.created_at ? moment(item.created_at).format("DD-MM-YYYY") : "",
          time: item.created_at ? moment(item.created_at).format("hh:mm A") : "",
          sent_role:
            item.noti_sent_role == 0 ? "Sent to All" : `Sent to ${item.role}`,
        }));
        setRowData(data);
      }
    });
  }

  function handleAcademy(e) {
    setAcaID(e || "");
    loadCirculars(e || "");
  }

  const exportToCSV = () => {
    const q = (v) => `"${(v == null ? "" : String(v)).replace(/"/g, '""')}"`;
    const header = columnDefs.map((c) => c.headerName);
    const lines = rowData.map((row) =>
      columnDefs.map((c) => q(row[c.field])).join(",")
    );
    const csv = [header.join(","), ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Circular Report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">Circular Report</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Reports</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Circular Report
          </li>
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h2 className="main-content-title tx-24 mg-b-5">Circular Report</h2>
            </div>
            <div className="card-body">
              <div className="row">
                {isSuperAdmin && (
                  <div className="col-xl-4 col-sm-6">
                    <label className="form-label">Select Academy</label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                    />
                  </div>
                )}

                <div className="col-xl-8 col-sm-6">
                  <div className="res-right mt-5">
                    <button
                      className="btn btn-success me-2"
                      onClick={exportToCSV}
                      disabled={rowData.length === 0}
                    >
                      Excel Download
                    </button>
                  </div>
                </div>
              </div>

              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={rowData}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CircularReport;
